import { useMutation } from '@tanstack/react-query';

import type { UpdateRiskAssessmentTemplatePayload } from 'api/RiskAssessmentTemplatesApi';
import { RiskAssessmentTemplatesApi } from 'api/RiskAssessmentTemplatesApi';
import { useFiRiskAssessmentCache } from 'tanstack-hooks/fi-risk-assessments/risk-assessments-cache';
import { RISK_ASSESSMENT_TEMPLATES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useUpdateRiskAssessmentTemplate() {
  const riskAssessmentTemplatesApi = new RiskAssessmentTemplatesApi();
  const { userBankId } = useUser();
  const { invalidateRiskAssessmentTemplates } = useFiRiskAssessmentCache();

  const { mutateAsync: updateRiskAssessmentTemplate, isPending: isUpdatingRiskAssessmentTemplate } =
    useMutation({
      mutationKey: [RISK_ASSESSMENT_TEMPLATES_KEY, 'update'],
      mutationFn: ({ id, ...data }: UpdateRiskAssessmentTemplatePayload & { id: string }) =>
        riskAssessmentTemplatesApi.updateRiskAssessmentTemplate(userBankId, id, data),
      onSuccess: () => {
        // An edit to a published template lands on a draft copy, so refetch every list variant.
        invalidateRiskAssessmentTemplates();
      },
      meta: {
        // No success message: the header's "Auto-saved" indicator is the confirmation.
        snackbarErrorMessage: 'There was an issue saving the template. Please contact support.'
      }
    });

  return { updateRiskAssessmentTemplate, isUpdatingRiskAssessmentTemplate };
}
